export default {
  SET_PLATFORM_LIST_LOADING: (state, { value }) =>
    (state.platforms_loading = value),
  SET_PLATFORM_LIST: (state, { platforms, hasMore, nextPage }) => {
    state.platforms = platforms;
    state.has_more = hasMore;
    state.next_page = nextPage;
  },
  CONCAT_PLATFORM_LIST: (state, { platforms, hasMore, nextPage }) => {
    state.platforms = state.platforms.concat(platforms);
    state.has_more = hasMore;
    state.next_page = nextPage;
  },
  SET_PLATFORM_SUBMITTING: (state, { value }) =>
    (state.platforms_submitting = value),
  SET_PLATFORM_ERROR: (state, { value }) => (state.platforms_error = value),
  SET_ACTIVE_PLATFORM: (state, { platform }) => (state.active_platform = platform),
  SET_PLATFORM_EDIT_MODE: (state, { value }) =>
    (state.is_edit_platform = value),
  CLEAR_PLATFORM_FORM_STATE: (state) => {
    state.platforms_error = "";
    state.platforms_submitting = false;
    state.active_platform = null;
    state.is_edit_platform = false;
  },
  SET_CONTENT_POLICY_SCHEMA_LOADING: (state, { value }) =>
    (state.schema_loading = value),
  SET_CONTENT_POLICY_SCHEMA: (state, { schema }) =>
    (state.content_policy_schema = schema),
};
